module.exports = __webpack_public_path__ + "static/Solar-Home-Lighting-System-c1b7f516334ae069056286402c8f7508.jpg";